import PropTypes from "prop-types";
import React from "react";

import { getBootstrapData } from "@swa-ui/bootstrap";
import { Link } from "@swa-ui/core";
import i18n from "@swa-ui/locale";

/**
 * MfaHelpLink is a link that directs the user to the MFA help page.
 */
export const MfaHelpLink = (props) => {
  const { className } = props;
  const { MFA_HELP } = getBootstrapData("urls");

  return <Link {...getNeedHelpLinkProps()}>{i18n("MfaHelpLink__NEED_HELP")}</Link>;

  function getNeedHelpLinkProps() {
    return {
      "aria-label": i18n("MfaHelpLink__NEED_HELP_ARIA"),
      className: className,
      href: MFA_HELP,
      newWindow: true,
    };
  }
};

MfaHelpLink.propTypes = {
  /**
   * Additional class names to apply to the component.
   */
  className: PropTypes.string,
};
